const pre = '/bcos/';

export default {
    path: '/bcos/browser',
    title: '区块浏览器',
    header: '',
    icon: 'md-aperture',
}